export default {
  /**
   *
   * @desc  判断是否为身份证号
   * @param  {String|Number} str
   * @return {Boolean}
   */
  isIdCard(str) {
    return /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(
      str
    );
  },

  /**
   *
   * @desc   判断是否为手机号
   * @param  {String|Number} str
   * @return {Boolean}
   */
  isPhoneNum(str) {
    return /^(0|86|17951)?(1[3-9][0-9])[0-9]{8}$/.test(str);
  },

  /**
   * 隐藏手机号中间四位
   */
  hidePhoneNum(phone) {
    return phone.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
  },

  /**
   *
   * @desc   判断是否为邮箱
   * @param  {String|Number} str
   * @return {Boolean}
   */
  isMail(str) {
    return /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/.test(str);
  },

  /**
   * set 页面 title
   */
  setTitle(title) {
    document.title = title;
  },

  /**
   * 设置cookie,注意cookie有一个域的问题，如果不指定path，cookie可能会存到不同的域下，
   * 这样就可能会导致cookie写入不成功，或者cookie没清掉
   */
  setCookie(name, value, exdays = 30) {
    let d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    let expires = "expires=" + d.toUTCString();
    document.cookie = name + "=" + value + "; " + expires + "; path=/";
  },

  /**
   * 获取cookie
   */
  getCookie(name) {
    let arr = document.cookie.match(new RegExp("(^| )" + name + "=([^;]*)(;|$)"));
    if (arr != null) return unescape(arr[2]);
    return null;
  },

  /**
   * 清除cookie
   */
  clearCookie(name) {
    this.setCookie(name, "", -1);
  },

  /**
   * 弹出 toast，传入vue 对象和 msg
   */
  showToast(vue, msg, position = "middle", duration = 3000) {
    vue.toast({ message: msg, position: position, duration: duration });
  },

  /**
   * 禁止页面滚动和解除滚动的共用函数，具体看这个文章
   * https://blog.csdn.net/qq_29606781/article/details/67650869
   * 1：相同事件绑定和解除，需要使用共用函数；绑定和解除事件时 事件没有"on" 即onclick写成click
   * 2：共用函数不能带参数；（即下面在调用的时候是用的 this.bodyScroll，不能带()。）
   */
  bodyScroll(event) {
    event.preventDefault();
  },

  /**
   * 禁止页面滚动，解决弹框出现时 IOS 上滚动穿透的问题
   */
  forbidBodyScroll() {
    document
      .getElementsByTagName("body")[0]
      .addEventListener("touchmove", this.bodyScroll, { passive: false });
  },

  /**
   * 解除禁止滚动，解决弹框出现时 IOS 上滚动穿透的问题
   */
  allowBodyScroll() {
    document.getElementsByTagName("body")[0].removeEventListener("touchmove", this.bodyScroll);
  },

  /**
   * 关掉键盘，并回到页面顶部，以解决iOS 12中键盘收起后页面底部会有一部分空白的问题
   */
  resetPageInIOS() {
    document.activeElement.blur();
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  },

  /**
   * 判断是否是微信浏览器
   */
  isInWeChat() {
    return /micromessenger/i.test(navigator.userAgent);
  },

  /**
   * 判断是否登录，以是否有 token 为判断依据
   */
  isLogin() {
    return !!this.getCookie("token");
  },

  /**
   * 去登录，携带当前页面的 URL，以便登录完了直接返回
   */
  goToLogin(vue, redirectUrl) {
    vue.$router.replace(`/login?redirect_url=${redirectUrl}`);
  },

  /**
   * 分享前处理内容，将内容中的所有标签和样式都去掉，仅保留文字，并去掉头尾和多余的空白字符，
   */
  pureTextForData(str) {
    if (!str) {
      return "";
    }

    let d = document.createElement("div");
    d.innerHTML = str;
    d = d.innerText.replace(/\s+/g, " ").trim();
    d = d.substring(0, 100);
    return d;
  },

  /**
   * 生成 guid
   */
  generateGuid() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, c => {
      let r = (Math.random() * 16) | 0,
        v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  },
  /**
   * 深拷贝
   * @param {} target
   */
  deepClone(target) {
    // 定义一个变量
    let result;
    // 如果当前需要深拷贝的是一个对象的话
    if (typeof target === "object") {
      // 如果是一个数组的话
      if (Array.isArray(target)) {
        result = []; // 将result赋值为一个数组，并且执行遍历
        for (let i in target) {
          // 递归克隆数组中的每一项
          result.push(this.deepClone(target[i]));
        }
        // 判断如果当前的值是null的话；直接赋值为null
      } else if (target === null) {
        result = null;
        // 判断如果当前的值是一个RegExp对象的话，直接赋值
      } else if (target.constructor === RegExp) {
        result = target;
      } else {
        // 否则是普通对象，直接for in循环，递归赋值对象的所有值
        result = {};
        for (let i in target) {
          result[i] = this.deepClone(target[i]);
        }
      }
      // 如果不是对象的话，就是基本数据类型，那么直接赋值
    } else {
      result = target;
    }
    // 返回最终结果
    return result;
  },
  getUrlParms(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
  },
  getConfigData(data, type) {
    const splitData = data.includes('&') && data.split('&');
    if(splitData) {
      let res = '';
      splitData.forEach(item => {
        const splitEquals = item.includes('=') && item.split('=');
        if(splitEquals && type == splitEquals[0]) {
          res = splitEquals[1];
        }
      });
      return res;
    }
  },
  filterPrice(value) {
    let res = value;
    const loginStatus = window.vm && !!window.vm.$store.getters['common/sysCfg'].sessionId;
    if(!res || isNaN(res) || typeof res === 'undefined' || res == 0 ) {
      res = '0';
    }
    // res = loginStatus ? Number(res).toFixed(2) :'???'
    res = Number(res).toFixed(2);
    return res;
  },
  isMiniApp() {
    const ua = navigator.userAgent.toLowerCase();
    let res = true;
    if(ua.match(/MicroMessenger/i)=="micromessenger") {
      res = true;        
    }else{
      res = false;
    }
    return res;
  },
  toAppPhone() {
    if(!this.isMiniApp()) {
      window.toAppPhone();
    }
  }
};
